import styled from '@emotion/styled';
import React from 'react';

import { Glyph } from '../common/Glyph';
import { TextSmall } from '../common/text/TextSmall';
import { Tooltip } from '../common/tooltip/Tooltip';

import { su, suPx } from '../../theme/functions/su';
import { glyph } from '../../theme/glyph';
import { theme } from '../../theme/theme';
import glyphStyles from '../common/Glyph.module.css';

export function Hint(props) {
  return (
    <Tooltip
      offset={suPx(1)}
      instant={true}
      renderTrigger={(triggerRef, triggerProps) => {
        return (
          <Hint.IconWrapper>
            <Glyph
              {...triggerProps}
              ref={triggerRef}
              size={theme.icon.size_default}
              source={glyph.core.infoCircleFill}
              color={theme.color.icon_light}
            />
          </Hint.IconWrapper>
        );
      }}
    >
      <Hint.Root color={theme.color.text_light}>{props.hint}</Hint.Root>
    </Tooltip>
  );
}

Hint.Root = styled(TextSmall)`
  max-width: 320px;
  padding: ${su(1)};
`;

Hint.IconWrapper = styled.div`
  vertical-align: text-top;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding-inline-end: ${su(1)};

  .${glyphStyles.root} {
    cursor: pointer;
  }
`;
